import { useCallback } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { GamesHero } from '../../components/banners/GamesHero';
import ChaseBar from '../../components/ChaseBar/ChaseBar';
import { Filters } from '../../components/Filters/Filters';
import { Footer } from '../../components/Footer/Footer';
import { CategoryGamesGrid } from '../../components/GamesList/CategoryGamesGrid';
import { Games } from '../../components/GamesList/Games';
import { SearchGamesGrid } from '../../components/GamesList/SearchGamesGrid';
import { useJackpotStart } from '../../components/GamesList/useJackpotStart';
import { GamesSearchHistory } from '../../components/GamesSearchHistory/GamesSearchHistory';
import { Loader } from '../../components/Loader/Loader';
import { LobbyPassBanner } from '../../components/LobbyPassBanner/LobbyPassBanner';
import { JackpotPromoCard } from '../../components/widgets/JackpotPromoCard/JackpotPromoCard';
import { HOME_CATEGORY_ID } from '../../stores/categories/CategoriesStore';
import { useStores } from '../../stores/useStores';

import styles from './Home.module.scss';
import { useHomeContentLogic } from './useHomeContentLogic';
import { useHomeResetScroll } from './useHomeResetScroll';

export const HomeContent = observer(() => {
  const { categoriesStore, gamesSearchStore, coinTypeStore } = useStores();

  const { isSearchInputOpenV2 } = gamesSearchStore;

  const { headerHeightForScroll, headerHeight, scrolledPercent, hideVisualEffects } = useHomeContentLogic();
  const intercomBodyMargin = getComputedStyle(document.body).marginTop;

  useHomeResetScroll();
  useJackpotStart();

  const isHeaderReady = headerHeightForScroll > 0 && headerHeight > 0;

  const closeSearch = useCallback(() => {
    if (!gamesSearchStore.isProviderSearch) {
      gamesSearchStore.closeSearch();
    }
  }, [gamesSearchStore]);

  return (
    <div
      className={styles.contentWrapper}
      style={{
        paddingTop: headerHeight - 1,
        top: `-${intercomBodyMargin}`,
      }}
    >
      <div className={styles.gamesHeroWrapper} onClick={closeSearch}>
        <GamesHero />
        <ChaseBar />
        {!hideVisualEffects && (
          <div
            className={classNames(
              styles.gradient,
              coinTypeStore.coinType === 'GC' ? styles.gradient__gc : styles.gradient__sc,
            )}
            style={{
              opacity: scrolledPercent / 100,
            }}
          />
        )}
      </div>
      {isHeaderReady ? (
        <div className={styles.homeContent}>
          <div
            className={styles.filtersWrapper}
            style={{
              marginTop: headerHeightForScroll,
              top: headerHeight - 1,
            }}
          >
            <LobbyPassBanner />
            <Filters />
          </div>

          <div className={styles.home}>
            {isSearchInputOpenV2 && <GamesSearchHistory />}
            {isSearchInputOpenV2 || gamesSearchStore.isProviderSearch ? (
              <SearchGamesGrid />
            ) : categoriesStore.currentId === HOME_CATEGORY_ID ? (
              <>
                {/*
                  FE_DESIGN_SPEC §7.4 variant B. There is no promo-card carousel on this lobby yet —
                  the only card carousel in the repo is the store's offer slider — so the card sits
                  at the top of the lobby promo area, above the game rows. It renders nothing unless
                  the jackpot is visible, so an absent jackpot leaves no gap. Placement needs design
                  sign-off; the component itself is drop-in for a carousel slide when one lands.
                */}
                <JackpotPromoCard />
                <Games />
              </>
            ) : (
              <CategoryGamesGrid />
            )}
          </div>
          <Footer />
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
});
